import { useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { classes, styles } from './utils';

export type TimeListProps = {
  className?: string;
  title?: string;
  options: { label: string; value: number }[];
  value?: number;
  onSelect: (value: number) => void;
};

export default function TimeList({
  className,
  title,
  options = [],
  value,
  onSelect,
}: TimeListProps) {
  const selectedRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    selectedRef.current?.scrollIntoView({ block: 'center' });
  }, [value]);

  return (
    <div className={twMerge(classes.wrapper, className)}>
      {title && <div className={classes.title}>{title}</div>}
      <List disablePadding className={classes.list}>
        {options.map((option) => {
          const isActive = option.value === value;
          return (
            <ListItem
              key={option.value}
              ref={isActive ? selectedRef : undefined}
              disablePadding
              className={classes.listItem}>
              <ListItemButton
                sx={styles.listItemButton(isActive)}
                className={classes.listItemButton}
                onClick={() => onSelect(option.value)}>
                {option.label}
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}
